import React from 'react'
import {
  BrowserRouter as Router,
  Route,
  Link
} from 'react-router-dom'
import Swiper from 'react-id-swiper';
import $ from 'jquery';
import matchHeight from 'jquery-match-height';

class Banner extends React.Component {
        render() {
          return (
          	<section className="team">
				  <div className="teaminner2">
				    <div className="teaminner">
				      <div className="teaminnermain">
				        <div className="container">
				          <div className="row">
				            <div className="col-md-6 breeserif titletext">
				              <h1 className="breeserif titletext">Building the Best<br />
				                Team for You.</h1>
				            </div>
				            <div className="col-md-6 visible-lg"><img src="images/MVP-Hero-Circle.png" alt="Banner" className="img-responsive center-block" /> </div>
				          </div>
				        </div>
				      </div>
				    </div>
				  </div>
				</section>
          );
        }
}

class MainContent extends React.Component {
        render() {
          return (
          	<div className="container">
				  <div className="infobox">
				    <div className="row">
				      <div className="col-lg-7">
				        <p className="flamaitalic font24 pad-bot-10 col-md-11">Staffing is a moving target.</p>
				        <p className="col-md-11 lineheight12">Sometimes a gap is caused by people leaving, being on vacation or calling in sick. Other times seasonal surges and business booms require additional resources. <span>MVP, Most Valuable Personnel</span>, will develop a game plan to ensure productivity and operational stability while allowing you to devote more time and energy to things you do best.</p>
				        <p className="flamaitalic font24 pad-top-10 col-md-11">At MVP, we are committed to your success.</p>
						  <p className="col-md-11"><a href="#discover" className="btn btn-default">Discover More <i className="fa fa-chevron-down" aria-hidden="true"></i></a></p> </div>
				    </div>
				  </div>
			</div>
          );
        }
}


class SubContent extends React.Component {
		componentDidMount() {
			$("body").on("click", ".videobox-one", function () {
			$(".videobox-one").html('<iframe src="https://player.vimeo.com/video/206431423?autoplay=1&title=0&byline=0&portrait=0" width="100%" height="400" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
			$(".videobox-one img").fadeOut(); 
			});	

			$("body").on("click", ".videobox-two", function () {
			$(".videobox-two").html('<iframe src="https://player.vimeo.com/video/206431397?autoplay=1&title=0&byline=0&portrait=0" width="100%" height="400" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
			$(".videobox-two img").fadeOut(); 
			});	

			$("body").on("click", ".videobox-three", function () {
			$(".videobox-three").html('<iframe src="https://player.vimeo.com/video/206431370?autoplay=1&title=0&byline=0&portrait=0" width="100%" height="400" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
			$(".videobox-three img").fadeOut(); 
			});	
		}	
	    render() {
        	var swiper =  {
            effect: 'slide',
            centeredSlides: true,   
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
	        paginationClickable: true,  
	        slidesPerView: 2,
	        spaceBetween: 65,
	        grabCursor: true,
	        loop: true,
	        breakpoints: {
	            767: {
	              slidesPerView: 'auto',
	        }
	        }
	        };
          return (
          <div>
          	<div className="container">
			  <div className="infobox-video">
			    <div className="row">
			      <div className="col-sm-12">
			        <h1><span className="video-bg">The MVP Playbook</span></h1>
			        <p className="flamaitalic font24 text-center">We offer a variety of staffing arrangements to <br />
			          meet your needs.</p>
			      </div>
			    </div>
			  </div>
			</div>

			<div className="container-fluid"> 
			  <div className="swiper-container">
			   <Swiper {...swiper}>
			      <div className="swiper-slide"><div className="videobox-one"><img src="images/Asset1Corp.png" alt="" /></div></div>
			      <div className="swiper-slide"><div className="videobox-two"><img src="images/Asset1Employee.png" alt="" /></div></div>
			      <div className="swiper-slide"><div className="videobox-three"><img src="images/Asset1Kurt.png" alt="" /></div></div>
			   </Swiper>
			  </div>
			</div>
		</div>	
          );
        }
}

class ServiceBox extends React.Component {
		componentDidMount() {
			$('.box').matchHeight({ property: 'min-height' });
		}
		render() {
          return (
          <div>
          	<div className="container" id="discover">
			  <section className="fullimg">
			    <div className="col-sm-12 col-md-6 col-lg-3">
			      <div className="box box-1">
			        <h4 className="breeserif">Temporary<br />
			          Staffing</h4>
			        <div className="equal-info">
			          <p className="flamaitalic font24 lineheight12">You need to have an operation that runs smoothly – no matter what.</p>
			          <p className="flamalight lineheight12 second-p">MVP can help you do just that by providing qualified, pre-screened workers in the numbers you need.</p>
			        </div>
			        <Link to="/services?section=services-temporary-staffing"  className="btn btn-default">MORE DETAILS</Link>
			      </div>
			    </div>
			    <div className="col-sm-12 col-md-6 col-lg-3">
			      <div className="box box-2">
			        <h4 className="breeserif">Temporary<br />to Permanent</h4>
			        <div className="equal-info">
			          <p className="flamaitalic font24 lineheight12">With semi-skilled or skilled positions, you’re making a more substantial investment.</p>
			          <p className="flamalight lineheight12 second-p">Taking a candidate for a test drive is a great way to hedge your bets.</p>
			        </div>
			        <Link to="/services?section=services-temporary-to-permanent"  className="btn btn-default">MORE DETAILS</Link>
			      </div>
			    </div>
			    <div className="col-sm-12 col-md-6 col-lg-3">
			      <div className="box box-3">
			        <h4 className="breeserif">Direct<br />Hire</h4>
			        <div className="equal-info">
			          <p className="flamaitalic font24 lineheight12" style={{"minHeight":"115px"}}>Recruitment and hiring can drain valuable time and finanical resources.</p>
			          <p className="flamalight lineheight12 second-p">We will do all the legwork to help you find the right employee.</p>
			        </div>
			        <Link to="/services?section=services-direct-hire"  className="btn btn-default">MORE DETAILS</Link>
			      </div>
			    </div>
			    <div className="col-sm-12 col-md-6 col-lg-3">
			      <div className="box box-4">
			        <h4 className="breeserif">On-Site<br />Programs</h4>
			        <div className="equal-info">
			          <p className="flamaitalic font24 lineheight12" style={{"minHeight":"100px"}}>The option of an on-site manager providing all administration.</p>
			          <p className="flamalight lineheight12 second-p">Day-to-day, payroll services, supervise employees, monitor performance, modifying schedules and more.</p>
			        </div>
			         <Link to="/services?section=services-onsight-solutions"  className="btn btn-default">MORE DETAILS</Link>
			      </div>
			    </div>
			  </section>
			</div>
			<div className="clearfix"></div>
			<div className="container">
			<section className="hire col-md-6" style={{"minHeight":"600px"}}>
			    <div className="box box-5">
				  <div className="col-md-2"></div>
			      <div className="text-center col-md-9">
			        <h1 className="breeserif">Human Resources and Back-Office Solutions</h1>
			        <p className="flamaitalic font24 lineheight12">We offer businesses a<br />one-stop shop for HR functions.</p>
			        <p className="flamalight font21 lineheight12">Relieving your organization of HR and back-office duties free up time and money than can be redirected into strategic growth.</p>
			       <div>
			        <Link to="/services?section=services-hr-back-office-solutions"  className="btn btn-default">MORE DETAILS</Link>
			       </div>
				 </div>
			     <div className="col-md-1"></div>
			  </div>
			</section>
			<section className="hire2 col-md-6" style={{"minHeight":"600px"}}>
			    <div className="box box-6">
				  <div className="col-md-1"></div>
			      <div className="text-center col-md-9">
			        <h1 className="breeserif">Managed <br />Services</h1>
			        <p className="flamaitalic font24 lineheight12">MVP has the<br />ultimate solution.</p>
			        <p className="flamalight font21 lineheight12">Let us become the employer of record for your personnel and assume all of the essential administrative tasks of human resources.</p>
			        <div>
			        <Link to="/services?section=services-managed-services"  className="btn btn-default">MORE DETAILS</Link>
			        </div>
			      </div>
				  <div className="col-md-2"></div>
			  </div>
			</section>
			</div>
		</div>	
          );
        }
}



function Home() {
  return (
  <div>
      <Banner />
      <MainContent />
      <SubContent />
      <ServiceBox />
  </div>    
  );
}

export default Home


// WEBPACK FOOTER //
// ./src/home.js